module.exports = __webpack_public_path__ + "static/media/ss13.6a304967.jpg";